@if (layerEnabled()) {
  <section class="identity-section">
    @if (!isVerified()) {
      <header class="identity-section__header">
        <div class="identity-section__header-copy">
          <h3 class="identity-section__title">
            {{ 'app.identity.profile.title' | translate }}
          </h3>
          <p class="identity-section__subtitle">
            {{ 'app.identity.profile.subtitle' | translate }}
          </p>
        </div>
      </header>
    }

    <div
      class="identity-section__body"
      [class.identity-section__body--standalone]="isVerified()"
    >
      <div class="identity-section__status">
        <span
          class="identity-section__badge"
          [class.identity-section__badge--verified]="isVerified()"
          [class.identity-section__badge--fully-verified]="isFullyVerified()"
          [class.identity-section__badge--grace]="inGracePeriod()"
          [class.identity-section__badge--pending]="shouldPromptVerification()"
        >
          {{ tierLabelKey() | translate }}
        </span>
        @if (isFullyVerified()) {
          <p class="identity-section__copy">
            {{ 'app.identity.profile.fullyVerifiedCopy' | translate }}
          </p>
        } @else if (isVerified()) {
          <p class="identity-section__copy">
            {{ 'app.identity.profile.verifiedCopy' | translate }}
          </p>
        } @else if (inGracePeriod()) {
          <p class="identity-section__copy">
            {{
              'app.identity.profile.graceCopy'
                | translate: { days: graceDaysRemaining() }
            }}
          </p>
          <app-parent-button variant="primary" (clicked)="startVerification()">
            {{ 'app.identity.profile.verifyCta' | translate }}
          </app-parent-button>
        } @else {
          <p class="identity-section__copy">
            {{ 'app.identity.profile.unverifiedCopy' | translate }}
          </p>
          <app-parent-button variant="primary" (clicked)="startVerification()">
            {{ 'app.identity.profile.verifyCta' | translate }}
          </app-parent-button>
        }
      </div>
    </div>
  </section>
}
